<fidelity-overlay-page-wrapper
    *transloco="let t; prefix: 'fidelity-app'"
    [headerCaption]="t('sign-in.heading')"
    [errorComponent]="errorComponent()"
>
    <div pageContent class="flex flex-col gap-y-2 items-center overflow-hidden h-full" *transloco="let gt">
        @if (brandsService.logoUrl) {
            <img class="mx-auto flex-shrink min-h-0 w-full object-contain" [src]="brandsService.logoUrl" alt="Logo image" />
        }

        <div [formGroup]="signInForm" class="grid w-full grid-cols-1 gap-y-2">
            <mat-form-field subscriptSizing="dynamic">
                <mat-label>
                    {{ gt('generic.email') }}
                </mat-label>
                <input matInput formControlName="email" autocomplete="email" />
            </mat-form-field>
            <mat-form-field subscriptSizing="dynamic">
                <mat-label>
                    {{ gt('generic.password') }}
                </mat-label>
                <input
                    matInput
                    type="password"
                    formControlName="password"
                    autocomplete="current-password"
                    #passwordField
                />
                <button
                    mat-icon-button
                    type="button"
                    (click)="
                        passwordField.type === 'password'
                            ? (passwordField.type = 'text')
                            : (passwordField.type = 'password')
                    "
                    matSuffix
                >
                    @if (passwordField.type === 'password') {
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                    }
                    @if (passwordField.type === 'text') {
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:eye-slash'"></mat-icon>
                    }
                </button>
            </mat-form-field>

            <!-- Actions -->
            <div class="mt-2 inline-flex w-full items-center justify-between">
                <div class="flex w-full flex-row justify-between items-center gap-y-4">
                    <div class="flex cursor-pointer justify-start">
                        <mat-checkbox formControlName="rememberMe" color="tb-primary" >{{ t('sign-in.remember-me') }}</mat-checkbox>
                    </div>
                    <a
                        class="cursor-pointer text-md font-medium text-primary underline"
                        (click)="openPage(availablePages.forgotPassword)"
                    >
                        {{ t('sign-in.forgot') }}
                    </a>
                </div>
            </div>

            <!-- prevent login button from being displayed in case of specific user confirmation error -->
            @if (errorCode() != CUSTOMER_ERRORS.USER_NOT_CONFIRMED) {
                <button
                    class="fuse-mat-button-large mt-6 w-full enabled:bg-tb-primary enabled:text-tb-primary-contrast"
                    mat-flat-button
                    [disabled]="!signInForm.valid || isLoading()"
                    (click)="signIn()"
                >
                    @if (isLoading()) {
                        <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
                    } @else {
                        <span>
                            {{ t('sign-in.sign-in-btn') }}
                        </span>
                    }
                </button>
            }
        </div>

        @if (fullErrorMessage()) {
            <div class="mt-4 rounded-md border border-warn bg-red-100 p-2 text-warn">
                {{ fullErrorMessage() }}
            </div>
        }

        @if (errorCode() == CUSTOMER_ERRORS.USER_NOT_CONFIRMED) {
            <button
                class="fuse-mat-button-large mt-6 w-full enabled:bg-tb-primary enabled:text-tb-primary-contrast"
                mat-flat-button
                [disabled]="signInForm.get('email')?.invalid || isLoading()"
                (click)="resendConfirm()"
            >
                @if (isLoading()) {
                    <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
                } @else {
                    <span>{{ t('sign-in.resend-confirmation') }}</span>
                }
            </button>
        }

        <p class="text-secondary mt-3 pt-3 border-t w-full text-center">
            {{ t('sign-in.not-registered') }}
            <span
                class="cursor-pointer font-medium text-primary underline"
                (click)="openPage(availablePages.register)">
                {{ t('sign-in.register') }}
            </span>
        </p>
    </div>
</fidelity-overlay-page-wrapper>
